// eslint-disable-next-line @typescript-eslint/no-var-requires
const defaultTheme = require('tailwindcss/defaultTheme');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const colors = require('tailwindcss/colors');

module.exports = {
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
  },
  purge: ['./public/**/*.html', './src/**/*.vue'],
  theme: {
    container: {
      center: true,
      padding: {
        DEFAULT: '2rem',
        sm: '2rem',
        lg: '4rem',
        xl: '5rem',
      },
    },
    extend: {
      zIndex: {
        2005: '2005',
      },
      spacing: {
        100: '28rem',
      },
      screens: {
        '3xl': '2160px',
      },
      fontFamily: {
        sans: ['Manrope', 'Inter var', ...defaultTheme.fontFamily.sans],
      },
      fontSize: {
        '2xs': '.625rem',
      },
      animation: {
        progress: 'progress 1s infinite linear',
      },
      keyframes: {
        progress: {
          '0%': { transform: ' translateX(0) scaleX(0)' },
          '40%': { transform: 'translateX(0) scaleX(0.4)' },
          '100%': { transform: 'translateX(100%) scaleX(0.5)' },
        },
      },
      transformOrigin: {
        'left-right': '0% 50%',
      },
      colors: {
        fuschia: colors.fuchsia,
        'brand-light-blue': '#F9FAFF',
        'brand-medium-blue': '#D8DFF6',
        'brand-gray-blue': '#BAC5EE',
        'brand-yellow': '#f7b200',
        'brand-blue': '#3c5ccf',
        'brand-green': {
          DEFAULT: '#28A671',
          light: '#9EF2C4',
        },
        'brand-red': {
          DEFAULT: '#ff715b',
          dark: '#e65a46',
          light: '#ff8e7a',
        },
        'brand-purple': {
          DEFAULT: '#811FA6',
          light: '#D091E7',
        },
        'brand-brown': '#6d6156',
        'brand-light-brown': '#6d615655',
        'brand-mid-brown': '#6d615688',
        'brand-medium-brown': '#6d6156bb',
        'brand-sand': '#F8EFE6',
        'brand-dark-sand': '#E0CFBF',
        'brand-light-sand': '#FCF7F3',
        'brand-black': '#1D1F27',
        'brand-ai-purple': {
          DEFAULT: '#694FF5',
          dark: /* make it 20% darker*/ '#4F3CBF',
          light: /* make it 20% lighter*/ '#8F6EFF',
        },
        'brand-ai-pink': {
          DEFAULT: '#E56575',
          dark: /* make it 20% darker*/ '#BF4F5F',
          light: /* make it 20% lighter*/ '#FF7080',
        },
        teal: {
          100: '#e6fffa',
          200: '#b2f5ea',
          300: '#81e6d9',
          400: '#4fd1c5',
          500: '#38b2ac',
          600: '#319795',
          700: '#2c7a7b',
          800: '#285e61',
          900: '#234e52',
        },
      },
    },
  },
  variants: {
    extend: {
      backgroundColor: ['odd'],
      flexGrow: ['first'],
    },
  },
};
